import { URL_PREFIX } from '../constants/api';

export interface WarehouseStatus {
  state: 'STARTED' | 'SUSPENDED' | 'RESUMING' | string;
}

export const getWarehouseStatus = async (): Promise<WarehouseStatus> => {
  const response = await fetch(
    `${URL_PREFIX}/api/v1/utility/warehouse-status?wake_up=true`,
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch warehouse status: ${response.statusText}`);
  }

  const data: WarehouseStatus = await response.json();

  if (data.state !== 'STARTED') {
    throw new Error(`Warehouse not ready. Status: ${data.state}`);
  }

  return data;
};
